<style lang="less">
input,
input:focus,
input:active {
  user-select: text;
  -webkit-user-select: text;
  zoom: 1;
}

#nav {
  display: none;
  position: absolute;
  background: rgba(0, 0, 0, 0.8);
  height: 100vh;
  width: 50%;
  top: 0px;
  z-index: 1000;

  li {
    height: 67px;
    margin-left: 10px;
    box-sizing: content-box;
    cursor: pointer;
    a {
      box-sizing: content-box;
      display: flex;
      height: 100%;
      align-items: center;
      margin: 0 auto;
      padding: 0 20px;
      color: white;
    }
    a.active {
      border-bottom: 3px solid #0bb20c;
      font-weight: 700;
    }
    .avatar {
      img {
        border-radius: 50%;
        width: 30px;
        height: 30px;
        margin-left: 50px;
      }
    }
  }
}

.app-header {
  height: 70px;
  width: 100%;
  position: fixed;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.06);
  background-color: #ffffff;
  opacity: 1;
  top: 0;
  z-index: 999;
  overflow: hidden;

  .cart-icon-wrap {
    display: none;
  }
  @media only screen and (max-width: 600px) {
    .nav {
      display: none;
    }
    .cart-icon-wrap {
      display: inline-block;
      height: 50px;
      width: 50px;
      position: relative;
      i {
        position: absolute;
        top: -8px;
      }

      .badge {
        position: absolute;
        background: red;
        width: 30px;
        height: 30px;
        border-radius: 15px;
        border: 1px white solid;
        text-align: center;
        vertical-align: middle;
        line-height: 30px;
        color: white;
        right: -1px;
      }
    }
  }

  .logo {
    img {
      width: 200px;
    }
  }
  .nav {
    height: 70px;
    align-items: center;
    font-size: 16px;
    li {
      height: 67px;
      margin-left: 40px;
      box-sizing: content-box;
      cursor: pointer;
      a {
        box-sizing: content-box;
        display: flex;
        height: 100%;
        align-items: center;
        margin: 0 auto;
        padding: 0 20px;
      }
      a.active {
        border-bottom: 3px solid #0bb20c;
        font-weight: 700;
      }
      .avatar {
        img {
          border-radius: 50%;
          width: 30px;
          height: 30px;
          margin: auto;
        }
      }
    }
  }
}
</style>
<template>
  <div id="app">
    <ul
      id="nav"
      class="nav flex-row"
    >
      <li class="flex-row flex-center">
        <router-link
          v-bind:class="{ active: isActive('buy')}"
          to="/"
        >订购商品</router-link>
      </li>
      <li class="flex-row flex-center">
        <router-link
          v-on:click="hideNav"
          v-bind:class="{ active: isActive('order')}"
          :to="{name: 'order-list'}"
        >我的订单</router-link>
      </li>
   
      <li class="flex-col flex-center">
        <div class="avatar flex-row">
          <img :src="user ? user.headimgurl : defaultAvatar" />
          <span style="font-size:12px;padding-top:5px;color:white;">{{user ? user.nickname : '-'}}</span>
        </div>
      </li>
    </ul>
    <div style="height:80px" />
    <div class="app-header">
      <div class="wrap flex-row flex-sb">
        <div class="logo flex-col flex-center">
          <a href="/">
            <img :src="logoUrl" />
          </a>
        </div>
        <ul class="nav flex-row">
          <li class="flex-row flex-center">
            <router-link
              v-bind:class="{ active: isActive('buy')}"
              to="/"
            >订购商品</router-link>
          </li>
          <li class="flex-row flex-center">
            <router-link
              v-bind:class="{ active: isActive('order')}"
              :to="{name: 'order-list'}"
            >我的订单</router-link>
          </li>

          <li class="flex-col flex-center">
            <div class="avatar flex-row flex-center">
              <img :src="user ? user.headimgurl : defaultAvatar" />
            </div>
            <span style="font-size:12px;padding-top:5px;">{{user ? user.nickname : "unkonw"}}</span>
          </li>
        </ul>
        <div>
          <a
            class="cart-icon-wrap"
            v-if="isActive('buy')"
            v-on:click="showCart"
          >
            <yd-icon
              size="44px"
              name="shopcart-outline"
            />

            <div
              class="badge"
              v-if="cartItems.length > 0"
            >
              <span>{{cartItems.length}}</span>
            </div>
          </a>

          <a
            id="nav-drawer-handle"
            v-on:click="showNav"
          >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </a>
        </div>
      </div>
    </div>
    <div class="app-content">
      <div class="block1">
        <router-view />
      </div>
    </div>
    <yd-backtop />
  </div>
</template>

<script>
import qs from "querystring";

const navActiveTypeMap = {
  buy: ["home", "flow"],
  order: ["order", "order-list"]
};

export default {
  name: "app",
  computed: {
    cartItems() {
      return this.$store.state.cart.items;
    },
    user() {
      return this.$store.state.user;
    }
  },
  data: () => ({
    logoUrl: window.logoUrl,
    defaultAvatar: window.defaultAvatar,
    erpUrl: window.erpUrl
  }),
  created() {
    var user = this.$store.state.user

    if (!user && location.href.indexOf("/login") < 0) {
      location.href = "/login"
      return
    }
      
  },
  methods: {
    isActive(type) {
      return (
        navActiveTypeMap[type].indexOf(this.$router.currentRoute.name) >= 0
      );
    },

    showCart() {
      document.body.className =
        document.body.className.indexOf("mobile-cart-show") >= 0
          ? ""
          : "mobile-cart-show";
    },
    showNav() {
      var navEle = document.getElementById("nav");
      navEle.style.display = navEle.style.display == "block" ? "none" : "block";
      window.scrollTo(0, 0);
    },
    hideNav() {
      navEle.style.display = "none";
    }
  }
};
</script>
